import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FilterlistPipeModule } from '../../../pipes';
import { TechnologyMapFieldsFormComponent } from './technology-map-fields-form.component';
import { RouterModule } from '@angular/router';
import {  MatButtonModule } from '@angular/material/button';
import {  MatFormFieldModule } from '@angular/material/form-field';
import {  MatSelectModule } from '@angular/material/select';
import {  MatTooltipModule } from '@angular/material/tooltip';
import { DisableAutocompleteDirectiveModule, TooltipIfTruncatedModule } from 'src/app/shared/directives';

@NgModule({
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        FontAwesomeModule,
        ReactiveFormsModule,
        FilterlistPipeModule,
        RouterModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatTooltipModule,
        TooltipIfTruncatedModule,
    ],
    declarations: [TechnologyMapFieldsFormComponent],
    exports: [TechnologyMapFieldsFormComponent],
})
export class TechnologyMapFieldsFormModule {}
